import api from "@/api";
import { defineStore } from "pinia";
import { Notice } from "@/interfaces/notice.interface";

export const useNoticeStore = defineStore({
  id: "noticeStore",
  state: () => ({
    notices: [] as Notice[], // Array of notices
    loader: {
      fetchNotices: false,
    },
  }),
  getters: {
    getNotices(): Notice[] {
      return this.notices;
    },
  },
  actions: {
    /**
     * Fetch notices for a specific school and optionally a class group
     */
    async fetchNotices(schoolId: string, classGroupId?: string) {
      this.loader.fetchNotices = true;
      this.notices = [];

      try {
        // Build the query parameters for classGroupId if provided
        const queryParams = classGroupId ? `?classGroupId=${classGroupId}` : "";

        // API request to fetch notices
        const response = await api.get(
          `/v2/organisation/notices/school/${schoolId}${queryParams}`
        );

        if (response.status === 200) {
          this.notices = response.data;
        } else {
          throw new Error("Failed to fetch notices.");
        }
      } catch (error) {
        console.error("Error fetching notices: ", error);
        this.notices = [];
      } finally {
        this.loader.fetchNotices = false;
      }
    },
  },
  persist: true, // Ensures the state is persisted across sessions
});
